import {
  Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/tel';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async list(params: any) {
    return api.list(params);
  }

  @Action
  async add(params: any) {
    return api.add(params);
  }

  @Action
  async logs(params: any) {
    return api.logs(params)
  }

  @Action
  async soundRecordingUrl(params: any) {
    return api.soundRecordingUrl(params)
  }
}
